import { render, staticRenderFns } from "./ElderlyOrderDisable.vue?vue&type=template&id=1df4f28e&scoped=true&"
import script from "./ElderlyOrderDisable.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrderDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4f28e",
  null
  
)

export default component.exports